@if (table()) {
  <div class="container-fluid mt-2 mt-md-4 px-0">
    <app-generic-card
      [title]="table()!.tableName"
      [description]="table()!.description"
      [showHeader]="false"
      [clampDescription]="false"
    >
      <div card-content>
        <div class="row">
          <div class="col-12">
            <h5 class="fw-bold mt-2">Dettagli Gioco</h5>
            <div class="row g-2">
              <div class="col-6">
                <p><strong>Gioco:</strong> {{ table()!.playedGame.gameName }}</p>
              </div>
              <div class="col-6">
                <p><strong>Giocatori:</strong> {{ table()!.minPlayers }} - {{ table()!.maxPlayers }}</p>
              </div>
              <div class="col-6">
                <p><strong>Età minima:</strong> {{ table()!.minAge != null ? table()!.minAge + '+' : 'Non specificata' }}</p>
              </div>
              <div class="col-6">
                <p><strong>Tipo:</strong> {{ table()!.isOnline ? 'Online' : 'Dal vivo' }}</p>
              </div>
            </div>

            @if (!table()!.isOnline && table()!.location) {
              <hr class="my-3" />
              <h5 class="fw-bold">Località</h5>
              @if (geoLocationService.mapsUrl(table()!.location)) {
                <p class="mb-1">
                  <i class="bi bi-geo-alt"></i>
                  <a
                    [href]="geoLocationService.mapsUrl(table()!.location)"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    class="link-primary text-decoration-none"
                  >
                    {{ geoLocationService.mapsLinkLabel(table()!.location) }}
                  </a>
                </p>
              } @else {
                <p class="mb-1">
                  <i class="bi bi-geo-alt"></i>
                  {{
                    geoLocationService.locationSubtitle(table()!.location) ||
                      geoLocationService.locationTitle(table()!.location)
                  }}
                </p>
              }
              <p class="small text-muted">{{ geoLocationService.locationTitle(table()!.location) }}</p>
            }

            @if (locationMarkers().length > 0) {
              <hr class="my-3" />
              <h5 class="fw-bold">Mappa</h5>
              @if (usesEventLocation()) {
                <p class="small text-muted">Posizione dell'evento associato</p>
              }
              <app-osm-map
                [markers]="locationMarkers()"
                [compact]="true"
                ariaLabel="Mappa della sede del tavolo"
              ></app-osm-map>
            }
          </div>

          <div class="col-12">
            <h5 class="fw-bold mt-2">Dettagli Tavolo</h5>
            <div class="row g-2">
              <div class="col-6">
                <p>
                  <strong>Organizzazione:</strong>
                  {{ table()!.organization?.organizationName || 'Da definire' }}
                </p>
              </div>
              <div class="col-6">
                <p><strong>Creatore:</strong> {{ isCreator() ? 'Si' : 'No' }}</p>
              </div>
            </div>
          </div>

          @if (table()!.event) {
            <div class="col-12">
              <h5 class="fw-bold mt-2">Evento associato</h5>
              <app-game-table-event-card [event]="table()!.event"></app-game-table-event-card>
            </div>
          }

          <div class="col-12 border-start-lg">
            <h5 class="fw-bold mt-2 mt-md-0">Partecipanti</h5>
            <ul class="list-unstyled">
              @for (participation of participationsSorted(); track participation.id) {
                <div class="mb-2 border border-secondary">
                  <div
                    class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between bg-light border rounded p-2 w-100"
                  >
                    <div
                      class="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2"
                      [ngClass]="participation.accepted ? 'text-success' : 'text-danger'"
                    >
                      <div class="d-flex align-items-center gap-2">
                        <i
                          class="bi"
                          [ngClass]="
                            participation.accepted ? 'bi-check-circle-fill' : 'bi-person-circle'
                          "
                        ></i>
                        <span class="fw-medium">{{ participation.userProfile.userName }}</span>
                      </div>

                      <small class="fw-bold text-uppercase ms-0 ms-md-1" style="font-size: 0.7rem">
                        ({{ participation.accepted ? 'Accettato' : 'In attesa' }})
                      </small>

                      @if (isUserCreator(participation.userProfile.userId)) {
                        <small
                          class="fw-bold text-uppercase ms-0 ms-md-1"
                          style="font-size: 0.7rem"
                        >
                          (Proprietario)
                        </small>
                      }

                      <small class="fw-bold text-uppercase ms-0 ms-md-1" style="font-size: 0.7rem">
                        {{ participation.createdDate | italianDate: 'dd/MM/yyyy HH:mm' }}
                      </small>
                    </div>

                    @if (isCreator()) {
                      <div class="d-flex gap-2 mt-2 mt-md-0">
                        @if (!participation.accepted && !table()!.isAutoAccept) {
                          <button class="btn btn-success btn-sm d-inline-flex align-items-center gap-1" (click)="accept(participation)">
                            <i class="bi bi-check-lg" aria-hidden="true"></i>Accetta
                          </button>
                        }
                        @if (participation.accepted) {
                          <button
                            class="btn btn-outline-danger btn-sm d-inline-flex align-items-center gap-1"
                            (click)="remove(participation)"
                            [disabled]="isUserCreator(participation.userProfile.userId)"
                          >
                            <i class="bi bi-person-x-fill" aria-hidden="true"></i>Rimuovi
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              } @empty {
                <p class="small text-muted fst-italic">Nessun partecipante ancora.</p>
              }
            </ul>
          </div>

          @if (table()!.id) {
            <div class="mx-auto">
              <app-game-table-sessions [table]="table()!" (sessionsChanged)="onSessionsChanged()">
              </app-game-table-sessions>
            </div>
          }
        </div>
      </div>

      <div card-actions class="d-flex flex-wrap gap-2">
        @if (canManage()) {
          <button class="btn btn-primary flex-grow-1" (click)="edit()">
            <i class="bi bi-pencil me-1" aria-hidden="true"></i>Modifica
          </button>
          <button class="btn btn-danger flex-grow-1" (click)="deleteTable()">
            <i class="bi bi-trash me-1" aria-hidden="true"></i>Elimina
          </button>
        }
        @if (canJoin()) {
          <button class="btn btn-success flex-grow-1" (click)="joinTable()">
            <i class="bi bi-person-plus-fill me-1" aria-hidden="true"></i>Partecipa
          </button>
        }
        @if (isParticipant()) {
          <button class="btn btn-danger flex-grow-1" (click)="remove(getUserParticipation())">
            <i class="bi bi-box-arrow-right me-1" aria-hidden="true"></i>Esci dal Tavolo
          </button>
        }
      </div>

      <div card-footer class="small text-muted py-2">
        <span>Creato il {{ table()!.createdDate | italianDate: 'dd/MM/yyyy HH:mm' }}</span>
        <span class="mx-2">|</span>
        <span [class]="table()!.isActive ? 'text-success' : 'text-danger'">
          {{ table()!.isActive ? 'Tavolo Attivo' : 'Tavolo Inattivo' }}
        </span>
      </div>
    </app-generic-card>
  </div>
}
